import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

@Component({})
export default class ClientFilterPanel extends Vue {
  loading = false;
  timerId: number | null = null;
  timerDelay = 500;

  @Prop({ default: "" }) search!: string;
  @Emit('search-change') searchChange(val: string) {
    return val
  }
  clear() {
    this.$nextTick(() => {
      this.searchChange('');
    });
  }
  onEnter(e: KeyboardEvent) {
    e.preventDefault();
    this.searchChange(this.search);
  } 
}
